import React from 'react';

const NotFound = () => {
  return (
    <div style={{textAlign:"center",margin:"50px"}}>
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFound;
